export default __webpack_public_path__ + "static/media/fci_logo.49130949.jpg";